import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import MediaQuery from 'react-responsive';
import { useSelector } from 'react-redux';
import ReactGA from 'react-ga';

import styles from '../Path/Path.module.css';
import Storage from '../Storage';
import Memory from '../Memory';
import Software from '../Software';
import RequestModal from '../../../RequestModal';
import checkDisabled from '../utils/checkDisabled';
import { REQUEST_PRICE_QOUTE } from '../../../../utils/constants';

const PlatformPath = (props) => {
  const { showModal } = props;
  const { formatMessage } = useIntl();

  const { config } = useSelector(state => state.config);

  const [selectedCpu, setSelectedCpu] = useState({});
  const [selectedPlatform, setSelectedPlatform] = useState({});
  const [selectedSoftware, setSelectedSoftware] = useState([]);
  const [selectedStorage, setSelectedStorage] = useState([]);
  const [selectedMemory, setSelectedMemory] = useState([]);
  const [showBasket, setShowBasket] = useState(false);

  return (
    <div className={styles.configurator}>
      <div className={styles['details-wrapper']}>
        <div className={styles.hr} />
        <div className={styles['options-group']}>
          <div className={`${styles['options-group_title']} Rubik-40pt`}>
            {formatMessage({id: 'OptionsGroup.platformTitle'})}
          </div>
          <div className={styles.options}>
            {
              config?.platforms?.map((platform, i) => {
                return (
                  <div className={`
                    ${styles['option-wrapper_radio']}
                    ${selectedPlatform.type === platform.type ? styles['option_active'] : ''}
                  `}
                    key={`platform-platform-path-${i}`}
                  >
                    <div className={styles['radio']}>
                      <input
                        type="radio"
                        name="platforms-platform-path"
                        value={platform.type}
                        checked={selectedPlatform.type === platform.type}
                        onChange={() => {
                          setSelectedStorage([]);
                          setSelectedMemory([]);
                          setSelectedPlatform(platform);
                        }}
                        id={`platforms-platform-path-${platform.type}`}
                      />
                      <label htmlFor={`platforms-platform-path-${platform.type}`}></label>
                    </div>
                    <div className={`
                      ${styles['option-title']}
                      Rubik-26pt
                    `}>
                      {platform.title}
                    </div>
                  </div>
                );
              })
            }
            {
              selectedPlatform?.description && (
                <div className={`${styles['selected-option_description']} Rubik-20pt`}>
                  { selectedPlatform.description }
                </div>
              )
            }
          </div>
        </div>
        <div className={styles.hr} />
        <div className={styles['options-group']}>
          <div className={`${styles['options-group_title']} Rubik-40pt`}>
            {formatMessage({id: 'OptionsGroup.cpuTitle'})}
          </div>
          <div className={styles.options}>
            {
              config?.cpus?.map((cpu, i) => {
                const disabled = checkDisabled(selectedPlatform?.cpus, cpu.type);
                return (
                  <div className={`
                    ${styles['option-wrapper_radio']}
                    ${selectedCpu.type === cpu.type ? styles['option_active'] : ''}
                  `}
                    key={`cpu-platform-path-${i}`}
                  >
                    <div className={styles['radio']}>
                      <input
                        type="radio"
                        name="cpus-platform-path"
                        value={cpu.type}
                        checked={selectedCpu.type === cpu.type}
                        disabled={disabled}
                        onChange={() => {
                          setSelectedStorage([]);
                          setSelectedMemory([]);
                          setSelectedCpu(cpu);
                        }}
                        id={`cpus-platform-path-${cpu.type}`}
                      />
                      <label htmlFor={`cpus-platform-path-${cpu.type}`}></label>
                    </div>
                    <div className={`
                      ${styles['option-title']}
                      ${disabled ? styles['option_disabled'] : ''}
                      Rubik-26pt
                    `}>
                      {cpu.title}
                    </div>
                  </div>
                );
              })
            }
            {
              selectedCpu?.description && (
                <div className={`${styles['selected-option_description']} Rubik-20pt`}>
                  { selectedCpu.description }
                </div>
              )
            }
          </div>
        </div>
        <Storage
          selectedPlatform={selectedPlatform}
          selectedStorage={selectedStorage}
          setSelectedStorage={setSelectedStorage}
          inputKey="platform"
        />
        <Memory
          selectedPlatform={selectedPlatform}
          selectedMemory={selectedMemory}
          setSelectedMemory={setSelectedMemory}
          inputKey="platform"
        />
        <Software
          selectedSoftware={selectedSoftware}
          setSelectedSoftware={setSelectedSoftware}
          inputKey="platform"
        />
      </div>
      <MediaQuery minDeviceWidth={1224}>
        <div className={styles['summary-wrapper']}>
          <div className={styles.summary}>
            <div className={`${styles['summary-title']} Rubik-40pt`}>
              {formatMessage({id: 'ConfigureOwn.Summary.title'})}
            </div>
            <div className={`${styles['summary-subtitle']} Rubik-26pt`}>
              {formatMessage({id: 'ConfigureOwn.Summary.subtitle'})}
            </div>
            <div className={styles['summary-specs']}>
              <ul>
                { selectedPlatform.type && (
                  <li
                    className={`${styles['summary-specs_item']} Rubik-20pt`}
                    key="selected-platform-platform-path"
                  >
                    { selectedPlatform?.title }
                  </li>
                )}
                { selectedCpu.type && (
                  <li
                    className={`${styles['summary-specs_item']} Rubik-20pt`}
                    key="selected-cpu-platform-path"
                  >
                    { selectedCpu?.title }
                  </li>
                )}
                { selectedStorage.map((storage, i) => {
                  if (!storage.amount || storage.amount === 0) {
                    return null;
                  }
                  return (
                    <li
                      className={`${styles['summary-specs_item']} Rubik-20pt`}
                      key={`selected-storage-platform-path-${i}`}
                    >
                      { `${storage.amount} x ${storage.title}` }
                    </li>
                  )}
                )}
                { selectedMemory.map((memory, i) => {
                  if (!memory.amount || memory.amount === 0) {
                    return null;
                  }
                  return (
                    <li
                      className={`${styles['summary-specs_item']} Rubik-20pt`}
                      key={`selected-memory-platform-path-${i}`}
                    >
                      { `${memory.amount} x ${memory.title}` }
                    </li>
                  )}
                )}
                { selectedSoftware.map((software, i) => (
                  <li
                    className={`${styles['summary-specs_item']} Rubik-20pt`}
                    key={`selected-software-platform-path-${i}`}
                  >
                    { software?.title }
                  </li>
                ))}
              </ul>
            </div>
            { selectedPlatform.type && (
              <div className={styles['summary-price-quote']}>
                <button
                  className={`${styles['summary-price-quote-button']} Rubik-20pt`}
                  onClick={() => {
                    ReactGA.set({ dimension8: REQUEST_PRICE_QOUTE });
                    showModal(RequestModal, {
                      selectedCpu,
                      selectedPlatform,
                      selectedStorage,
                      selectedMemory,
                      selectedSoftware,
                    })
                  }}
                >
                  {formatMessage({id: 'ConfigureOwn.Summary.priceQuote'})}
                </button>
              </div>
            )}
          </div>
        </div>
      </MediaQuery>
      <MediaQuery maxDeviceWidth={1224}>
        <div className={styles['summary-price-quote']}>
          <button
            className={`${styles['summary-price-quote-button']} Rubik-20pt`}
            onClick={() => setShowBasket(true)}
          >
            {formatMessage({id: 'ConfigureOwn.Summary.priceQuote'})}
          </button>
        </div>
        <div className={`${styles['menu']} ${showBasket ? '' : styles['menu-hidden']}`}>
          <div className={styles['menu-collapse']}>
            <button
              onClick={() => setShowBasket(false)}
              className={styles['menu-collapse-icon']}>&#xf00d;</button>
          </div>
          <div className={styles['divider']}></div>
          <div className={styles.summary}>
            <div className={`${styles['summary-title']} Rubik-40pt`}>
              {formatMessage({id: 'ConfigureOwn.Summary.title'})}
            </div>
            <div className={`${styles['summary-subtitle']} Rubik-26pt`}>
              {formatMessage({id: 'ConfigureOwn.Summary.subtitle'})}
            </div>
            <div className={styles['summary-specs']}>
              <ul>
                { selectedPlatform.type && (
                  <li
                    className={`${styles['summary-specs_item']} Rubik-20pt`}
                    key="selected-platform-platform-path"
                  >
                    { selectedPlatform?.title }
                  </li>
                )}
                { selectedCpu.type && (
                  <li
                    className={`${styles['summary-specs_item']} Rubik-20pt`}
                    key="selected-cpu-platform-path"
                  >
                    { selectedCpu?.title }
                  </li>
                )}
                { selectedStorage.map((storage, i) => {
                  if (!storage.amount || storage.amount === 0) {
                    return null;
                  }
                  return (
                    <li
                      className={`${styles['summary-specs_item']} Rubik-20pt`}
                      key={`selected-storage-platform-path-${i}`}
                    >
                      { `${storage.amount} x ${storage.title}` }
                    </li>
                  )}
                )}
                { selectedMemory.map((memory, i) => {
                  if (!memory.amount || memory.amount === 0) {
                    return null;
                  }
                  return (
                    <li
                      className={`${styles['summary-specs_item']} Rubik-20pt`}
                      key={`selected-memory-platform-path-${i}`}
                    >
                      { `${memory.amount} x ${memory.title}` }
                    </li>
                  )}
                )}
                { selectedSoftware.map((software, i) => (
                  <li
                    className={`${styles['summary-specs_item']} Rubik-20pt`}
                    key={`selected-software-platform-path-${i}`}
                  >
                    { software?.title }
                  </li>
                ))}
              </ul>
            </div>
            <div className={styles['summary-price-quote']}>
              <button
                className={`${styles['summary-price-quote-button']} Rubik-20pt`}
                onClick={() => {
                  ReactGA.set({ dimension8: REQUEST_PRICE_QOUTE });
                  showModal(RequestModal, {
                    selectedCpu,
                    selectedPlatform,
                    selectedStorage,
                    selectedMemory,
                    selectedSoftware,
                  })
                }}
              >
                {formatMessage({id: 'ConfigureOwn.Summary.priceQuote'})}
              </button>
            </div>
          </div>
        </div>
      </MediaQuery>
    </div>
  );
};

export default PlatformPath;
